import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ViewApplicationLocationItamsConstants } from "./view-application-location-itams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { take } from "rxjs/operators";
let ViewApplicationLocationItamsComponent = class ViewApplicationLocationItamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    changeDetectorRefs;
    routerParamsService;
    active;
    baysForm;
    validationMessages = ViewApplicationLocationItamsConstants.VALIDATION_MESSAGES;
    addressControl = ViewApplicationLocationItamsConstants.ADDRESS_CONTROL;
    bayNumberControl = ViewApplicationLocationItamsConstants.BAY_NUMBER_CONTROL;
    baySizeControl = ViewApplicationLocationItamsConstants.BAY_SIZE_CONTROL;
    geometryControl = ViewApplicationLocationItamsConstants.GEOMETRY_CONTROL;
    baysFormGroupName = ViewApplicationLocationItamsConstants.BAYS_FORM_GROUP_NAME;
    centroidFromControlName = ViewApplicationLocationItamsConstants.CENTROID_CONTROL;
    addressTextPlaceHolder = ViewApplicationLocationItamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    bayNumberPlaceHolder = ViewApplicationLocationItamsConstants.BAY_NUMBER_PLACEHOLDER;
    baySizeTextPlaceHolder = ViewApplicationLocationItamsConstants.BAY_SIZE_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeBayLabel = ViewApplicationLocationItamsConstants.REMOVE_BAY_LABEL;
    baysControl = ViewApplicationLocationItamsConstants.BAYS_CONTROL;
    applicationLoaded = false;
    application;
    mapComponent;
    isMapLoaded = false;
    getTrueCentroidSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
        this.listenForSelectedApplication();
        this.getMetadata();
    }
    ngOnInit() {
        this.listenForRouteParamChange();
    }
    loadMetadata() {
    }
    ngAfterViewInit() {
        this.mapService.actionBayEnabled = false;
    }
    getBays() {
        if (this.baysForm) {
            return this.baysForm.get(this.baysControl);
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    handleRouteChange() {
    }
    initForm() {
        this.baysForm = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(take(1)).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.application = application;
                    this.setApplicationData();
                    this.applicationLoaded = true;
                }
            }
        });
    }
    setApplicationData() {
        if (this.application && this.application.bays && this.application.bays.length > 0) {
            if (!this.getBays()) {
                return;
            }
            else {
                this.getBays().clear();
                const baysFormArray = this.getBays();
                this.selectedApplication?.bays?.sort((a, b) => (b?.id - a?.id));
                this.application.bays.forEach((bay) => {
                    // create form groups for each bay
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(bay.shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    const newBayFormGroup = this.createFormGroup(bay, geom);
                    this.setTrueCentroid(geometryArc, newBayFormGroup, baysFormArray);
                    this.syncMapGeometries();
                });
            }
        }
    }
    createFormGroup(savedBay, geom) {
        return new FormGroup({
            id: new FormControl(savedBay.id),
            bay: new FormControl(savedBay),
            address: new FormControl(savedBay.address, [Validators.required]),
            geometry: new FormControl(geom),
            bayNumber: new FormControl(savedBay.bayNumber),
            baySize: new FormControl(savedBay.baySize),
            centroid: new FormControl(null, [Validators.required])
        });
    }
    setTrueCentroid(geometryArc, newBayFormGroup, bayFormArray) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newBayFormGroup.get(this.centroidFromControlName).setValue(response.results[0].value);
                bayFormArray.push(newBayFormGroup);
                this.active = bayFormArray.length - 1;
                this.disableBayControls(bayFormArray.length - 1);
                this.syncMapGeometries();
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    disableBayControls(bayIndex) {
        const bayControl = this.getBays().controls[bayIndex];
        bayControl.get(this.addressControl).disable();
        bayControl.get(this.bayNumberControl).disable();
        bayControl.get(this.baySizeControl).disable();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getBays().controls.forEach(item => {
            const geom = item.get(this.geometryControl).value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, ViewApplicationLocationItamsConstants.LAYER_REF, true);
        }
        this.changeDetectorRefs.markForCheck();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationItamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationItamsComponent);
export { ViewApplicationLocationItamsComponent };
